import fellesIntl from "~/shared/intl";
import type { Customer } from "~/shared/reducers/customer";
import { IPS_PRODUCT_IDS } from "~/utils/policies";

export const paymentMethod = {
	BANK: "BANK",
	AVTALEGIRO: "AVTALEGIRO",
} as const;
export type PaymentMethod = keyof typeof paymentMethod;

export const products = {
	IPS: "IPS",
	PENSJONSKONTO: "PENSJONSKONTO",
} as const;
export type Products = ObjectValues<typeof products>;

const productNames = {
	IPS: fellesIntl.formatMessage({
		id: "produkt.ips",
		description: "Navn på ips product",
		defaultMessage: "Pensjonssparing med skattefordel (IPS)",
	}),
	PENSJONSKONTO: fellesIntl.formatMessage({
		id: "produkt.psk",
		description: "Navn på psk produkt",
		defaultMessage: "Pensjonssparekonto",
	}),
};

const productNamesLo = {
	IPS: fellesIntl.formatMessage({
		id: "produkt.ips.lo",
		description: "Navn på ips product hvis LO medlem",
		defaultMessage: "LOfavør Pensjonssparing med skattefordel (IPS)",
	}),
	PENSJONSKONTO: fellesIntl.formatMessage({
		id: "produkt.psk.lo",
		description: "Navn på psk produkt hvis LO medlem",
		defaultMessage: "LOfavør Pensjonssparekonto",
	}),
};

const productIds = {
	IPS: "73",
	PENSJONSKONTO: "65",
};

const productIdsLo = {
	IPS: "96",
	PENSJONSKONTO: "95",
};

export const getProductName = (product: Products, loProduct?: boolean): string => (loProduct ? productNamesLo[product] : productNames[product]);

export const getProductId = (product: Products, loProduct: boolean): string => (loProduct ? productIdsLo[product] : productIds[product]);

export const canStartSavings = (customer: Customer, age: number = 0) =>
	(customer.authenticated ? customer.age : age) < 75 &&
	(customer.authenticated ? customer.age : age) > 17 &&
	(!customer.foreignAddress || !!customer.address.validForeignAddress) &&
	!customer.dNumber;

export const canStartIps = (customer, policies) => canStartSavings(customer) && !policies.some((p) => IPS_PRODUCT_IDS.includes(p.produktId));

export const canStartPensjonssparekonto = (customer) => canStartSavings(customer) && customer.age < 66;
